<div class="container-fluid p-0 helper-background-white">
  <div class="container">
    <div class="col-md-5 ps-md-4 pt-md-3">
      <h1 class="pe-5 me-5">Benefits overview for 2025</h1>
      <p class="fw-bold">Annual Enrollment is over; here's an overview of your 2025 benefits.</p>
      <p class="m-0">Your health and wellbeing have never been more important. We’re committed to helping you and your family feel supported and secure – during these times and always. Knowing what your options are and what they mean is very important when making a decision that is most comfortable for you and your family.</p>
    </div>
  </div>
  <div class="custom-shape-divider-bottom">
    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
      <path d="M598.97 114.72L0 0 0 120 1200 120 1200 0 598.97 114.72z" class="shape-fill"></path>
    </svg>
  </div>
</div>
